// --------------------------------------------------- Provider Connection Pages
import ProviderConnectionListPage from '../pages/shipperUi/provider/connections/ProviderConnectionListPage.vue'
import ProviderConnectionCreatePage from '../pages/shipperUi/provider/connections/ProviderConnectionCreatePage.vue'
import ProviderConnectionEditPage from '../pages/shipperUi/provider/connections/ProviderConnectionEditPage.vue'

// ----------------------------------------------- Manage Shipper Location Pages
import ShipperRootPage from '../pages/shipperUi/shipperLocations/ShipperRootPage.vue'
import ShipperItemPage from '../pages/shipperUi/shipperLocations/ShipperItemPage.vue'
import ShipperItemEditDetailsPage from '../pages/shipperUi/shipperLocations/ShipperItemEditDetailsPage.vue'
import ShipperItemEditLicensesPage from '../pages/shipperUi/shipperLocations/ShipperItemEditLicensesPage.vue'

// ---------------------------------------------------------- Submit Order Pages
import ProviderOrderListPage from '../pages/shipperUi/provider/orders/ProviderOrderListPage.vue'
import ProviderOrderSubmitPage from '../pages/shipperUi/provider/orders/ProviderOrderSubmitPage.vue'

// ---------------------------------------------------------- Manage Order Pages
import OrderListRootPage from '../pages/shipperUi/orders/OrderListRootPage.vue'
import OrderListPlacedPage from '../pages/shipperUi/orders/OrderListPlacedPage.vue'
import OrderListBeingScheduledPage from '../pages/shipperUi/orders/OrderListBeingScheduledPage.vue'
import OrderListScheduledPage from '../pages/shipperUi/orders/OrderListScheduledPage.vue'
import OrderListRescheduledPage from '../pages/shipperUi/orders/OrderListRescheduledPage.vue'
import OrderListOnDeliveryPage from '../pages/shipperUi/orders/OrderListOnDeliveryPage.vue'
import OrderListDeliveredPage from '../pages/shipperUi/orders/OrderListDeliveredPage.vue'
// import OrderListRejectedPage from '../pages/shipperUi/orders/OrderListRejectedPage.vue'
import OrderListCanceledPage from '../pages/shipperUi/orders/OrderListCanceledPage.vue'

// ------------------------------------------------------------ Order Info Pages
import OrderInfoRootPage from '../pages/shipperUi/orders/OrderInfoRootPage.vue'
import OrderInfoOverview from '../pages/shipperUi/orders/OrderInfoOverview.vue'
import OrderInfoTrackingHistory from '../pages/shipperUi/orders/OrderInfoTrackingHistory.vue'
import OrderInfoSupportingDocuments from '../pages/shipperUi/orders/OrderInfoSupportingDocuments.vue'
import OrderInfoAttachmentDocuments from '../pages/shipperUi/orders/OrderInfoAttachmentDocuments.vue'
import OrderInfoRouteInfo from '../pages/shipperUi/orders/OrderInfoRouteInfo.vue'
import OrderInfoMessages from '../pages/shipperUi/orders/OrderInfoMessages.vue'

// ---------------------------------------------------------- Manage Credit Pages
import CreditListPage from '../pages/shipperUi/credits/CreditListPage.vue'

// -------------------------------------------------------- Manage Vehicle Pages
import VehicleListPage from '../pages/shipperUi/vehicles/VehicleListPage.vue'
import VehicleRootPage from '../pages/shipperUi/vehicles/VehicleRootPage.vue'
import VehicleItemPage from '../pages/shipperUi/vehicles/VehicleItemPage.vue'
import VehicleItemEditPage from '../pages/shipperUi/vehicles/VehicleItemEditPage.vue'

// ---------------------------------------------------- Manage Vehicle Lot Pages
import VehicleLotItemPage from '../pages/shipperUi/vehicleLot/VehicleLotItemPage.vue'
import VehicleLotItemEditPage from '../pages/shipperUi/vehicleLot/VehicleLotItemEditPage.vue'

// ---------------------------------------------------------- Manage Route Pages
import RouteListRootPage from '../pages/shipperUi/routes/RouteListRootPage.vue'
import RouteListCreatedPage from '../pages/shipperUi/routes/RouteListCreatedPage.vue'
import RouteListDispatchedPage from '../pages/shipperUi/routes/RouteListDispatchedPage.vue'
import RouteListOnDeliveryPage from '../pages/shipperUi/routes/RouteListOnDeliveryPage.vue'
import RouteListCompletedPage from '../pages/shipperUi/routes/RouteListCompletedPage.vue'
import RouteListCanceledPage from '../pages/shipperUi/routes/RouteListCanceledPage.vue'
import RouteBuilderPage from '../pages/shipperUi/routes/RouteBuilderPage.vue'

// ------------------------------------------------------------ Route Info Pages
import RouteInfoRootPage from '../pages/shipperUi/routes/RouteInfoRootPage.vue'
import RouteInfoOverview from '../pages/shipperUi/routes/RouteInfoOverview.vue'
import RouteInfoDetailedStatus from '../pages/shipperUi/routes/RouteInfoDetailedStatus.vue'
import RouteInfoDrivingDirections from '../pages/shipperUi/routes/RouteInfoDrivingDirections.vue'

// ------------------------------------------------------- Manage Delivery Pages
import DeliveryListRootPage from '../pages/shipperUi/deliveries/DeliveryListRootPage.vue'
import DeliveryListDispatchedPage from '../pages/shipperUi/deliveries/DeliveryListDispatchedPage.vue'
import DeliveryListOnDeliveryPage from '../pages/shipperUi/deliveries/DeliveryListOnDeliveryPage.vue'
import DeliveryListCompletedPage from '../pages/shipperUi/deliveries/DeliveryListCompletedPage.vue'
import DeliveryListCanceledPage from '../pages/shipperUi/deliveries/DeliveryListCanceledPage.vue'
import ActiveDeliveryRootPage from '../pages/shipperUi/deliveries/ActiveDeliveryRootPage.vue'
import ActiveDeliveryStepperPage from '../pages/shipperUi/deliveries/ActiveDeliveryStepperPage.vue'

const routes = [
  // ------------------------------------------------- Provider Connection Pages
  {
    path: '/provider/connections',
    name: 'provider-connection-list',
    component: ProviderConnectionListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },
  {
    path: '/provider/connection/:providerAlias',
    name: 'provider-connection-create',
    component: ProviderConnectionCreatePage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },
  {
    path: '/provider/connection/:connectionId/manage',
    name: 'provider-connection-edit',
    component: ProviderConnectionEditPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },

  // --------------------------------------------- Manage Shipper Location Pages
  {
    path: '/shipper/:shipperId',
    component: ShipperRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper', 'sys-admin']
    },
    children: [
      {
        path: '/',
        name: 'shipper-item',
        component: ShipperItemPage,
        props: true
      },
      {
        path: 'edit-details',
        name: 'shipper-item-edit-details',
        component: ShipperItemEditDetailsPage,
        props: true
      },
      {
        path: 'edit-licenses',
        name: 'shipper-item-edit-licenses',
        component: ShipperItemEditLicensesPage,
        props: true
      },
      {
        path: '*',
        redirect: '/shippers'
      }
    ]
  },

  // -------------------------------------------------------- Submit Order Pages
  {
    path: '/provider/orders',
    name: 'provider-order-list',
    component: ProviderOrderListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },
  {
    path: '/provider/order/:providerAlias/:accountId/:brandId/:orderId/submit',
    name: 'provider-order-submit',
    component: ProviderOrderSubmitPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },
  {
    path: '/provider/order/:providerAlias/:accountId/:brandId/:orderId/issue-credit',
    name: 'provider-order-issue-credit',
    component: ProviderOrderSubmitPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },

  // -------------------------------------------------------- Manage Order Pages
  {
    path: '/orders',
    component: OrderListRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    },
    children: [
      {
        path: 'placed',
        name: 'order-list-placed',
        component: OrderListPlacedPage,
        props: true
      },
      {
        path: 'being-scheduled',
        name: 'order-list-being-scheduled',
        component: OrderListBeingScheduledPage,
        props: true
      },
      {
        path: 'scheduled',
        name: 'order-list-scheduled',
        component: OrderListScheduledPage,
        props: true
      },
      {
        path: 'rescheduled',
        name: 'order-list-rescheduled',
        component: OrderListRescheduledPage,
        props: true
      },
      {
        path: 'on-delivery',
        name: 'order-list-on-delivery',
        component: OrderListOnDeliveryPage,
        props: true
      },
      {
        path: 'delivered',
        name: 'order-list-delivered',
        component: OrderListDeliveredPage,
        props: true
      },
      {
        path: 'canceled',
        name: 'order-list-canceled',
        component: OrderListCanceledPage,
        props: true
      },
      // {
      //   path: 'rejected',
      //   name: 'order-list-rejected',
      //   component: OrderListRejectedPage,
      //   props: true
      // },
      {
        path: '*',
        redirect: '/orders/placed'
      }
    ]
  },

  // ---------------------------------------------------------- Order Info Pages
  {
    path: '/order/:orderId',
    component: OrderInfoRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    },
    children: [
      {
        path: 'overview',
        name: 'order-info-overview',
        component: OrderInfoOverview,
        props: true
      },
      {
        path: 'tracking-history',
        name: 'order-info-tracking-history',
        component: OrderInfoTrackingHistory,
        props: true
      },
      {
        path: 'supporting-docs',
        name: 'order-info-supporting-docs',
        component: OrderInfoSupportingDocuments,
        props: true
      },
      {
        path: 'attachment-docs',
        name: 'order-info-attachment-docs',
        component: OrderInfoAttachmentDocuments,
        props: true
      },
      {
        path: 'route-info',
        name: 'order-info-route-info',
        component: OrderInfoRouteInfo,
        props: true
      },
      {
        path: 'messages',
        name: 'order-info-messages',
        component: OrderInfoMessages,
        props: true
      },
      {
        path: '*',
        redirect: '/order/:orderId'
      }
    ]
  },

  // ------------------------------------------------------- Manage Credit Pages
  {
    path: '/credits',
    name: 'credit-list-issued',
    component: CreditListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },

  // ------------------------------------------------------ Manage Vehicle Pages
  {
    path: '/vehicles',
    name: 'vehicle-list',
    component: VehicleListPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },
  {
    path: '/vehicle/new',
    name: 'vehicle-item-new',
    component: VehicleItemEditPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },
  {
    path: '/vehicle/:vehicleId',
    component: VehicleRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    },
    children: [
      {
        path: '/',
        name: 'vehicle-item',
        component: VehicleItemPage,
        props: true
      },
      {
        path: 'edit',
        name: 'vehicle-item-edit',
        component: VehicleItemEditPage,
        props: true
      },
      {
        path: '*',
        redirect: '/vehicles'
      }
    ]
  },

  // -------------------------------------------------- Manage Vehicle Lot Pages
  {
    path: '/vehicle-lot',
    name: 'vehicle-lot-item',
    component: VehicleLotItemPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },
  {
    path: '/vehicle-lot/:vehicleLotId',
    name: 'vehicle-lot-edit',
    component: VehicleLotItemEditPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },

  // -------------------------------------------------------- Manage Route Pages
  {
    path: '/routes',
    component: RouteListRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    },
    children: [
      {
        path: 'created',
        name: 'route-list-created',
        component: RouteListCreatedPage,
        props: true
      },
      {
        path: 'dispatched',
        name: 'route-list-dispatched',
        component: RouteListDispatchedPage,
        props: true
      },
      {
        path: 'on-delivery',
        name: 'route-list-on-delivery',
        component: RouteListOnDeliveryPage,
        props: true
      },
      {
        path: 'completed',
        name: 'route-list-completed',
        component: RouteListCompletedPage,
        props: true
      },
      {
        path: 'canceled',
        name: 'route-list-canceled',
        component: RouteListCanceledPage,
        props: true
      },
      {
        path: '*',
        redirect: '/admin/routes/created'
      }
    ]
  },
  {
    path: '/build/route/:routeId',
    name: 'route-builder',
    component: RouteBuilderPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    }
  },

  // ---------------------------------------------------------- Route Info Pages
  {
    path: '/route/:routeId',
    component: RouteInfoRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    },
    children: [
      {
        path: 'overview',
        name: 'route-info-overview',
        component: RouteInfoOverview,
        props: true
      },
      {
        path: 'status',
        name: 'route-info-detailed-status',
        component: RouteInfoDetailedStatus,
        props: true
      },
      {
        path: 'directions',
        name: 'route-info-driving-directions',
        component: RouteInfoDrivingDirections,
        props: true
      },
      {
        path: '*',
        redirect: '/route/:routeId'
      }
    ]
  },

  // ------------------------------------------- Manage Delivery Pages (Drivers)
  {
    path: '/deliveries',
    component: DeliveryListRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    },
    children: [
      {
        path: 'dispatched',
        name: 'delivery-list-dispatched',
        component: DeliveryListDispatchedPage,
        props: true
      },
      {
        path: 'on-delivery',
        name: 'delivery-list-on-delivery',
        component: DeliveryListOnDeliveryPage,
        props: true
      },
      {
        path: 'completed',
        name: 'delivery-list-completed',
        component: DeliveryListCompletedPage,
        props: true
      },
      {
        path: 'canceled',
        name: 'delivery-list-canceled',
        component: DeliveryListCanceledPage,
        props: true
      },
      {
        path: '*',
        redirect: '/deliveries/dispatched'
      }
    ]
  },
  {
    path: '/delivery/:routeId',
    component: ActiveDeliveryRootPage,
    props: true,
    meta: {
      requiresAuth: true,
      ui_type: ['shipper']
    },
    children: [
      {
        path: '/',
        name: 'delivery-stepper',
        component: ActiveDeliveryStepperPage,
        props: true
      },
      {
        path: '*',
        redirect: '/deliveries'
      }
    ]
  }
]

export default routes
